import { useTranslation } from "react-i18next";
import { formatOnlyDateForGui } from "../pages/utils";

import { useContext, useEffect, useState } from "react";
import InitContext from "../pages/InitContext";
import useMmcService from "../../services/MmcService";
import ErrorMessage from "../errorMessage/ErrorMessage";
import { Consts } from "../pages/consts";

const Diseases = ({ patient }) => {
  const { t: t } = useTranslation();
  const [patientDiseases, setPatientDiseases] = useState([]);
  const context = useContext(InitContext);

  const { error, clearError, getDbDiseases } =
    useMmcService();

  useEffect(() => {
    clearError();

    if (patient?.id) {
      getDbDiseases(context?.token, patient?.id).then((data) =>
        handleDiseases(data),
      );
    }
  }, [patient]);

  const handleDiseases = (data) => {
    if (data) {
      const { diseases } = data;

      if (diseases && Array.isArray(diseases)) {
        setPatientDiseases(diseases);
      }
    }
  };

  const createDiseaseItemBody = (item) => {
    return (
      <div className="w3-container w3-left-align">
        <div className="w3-row">
          <label className="bold-label">{t("icd10_code")}:</label>
          <label className="label-margin-left">{item?.icd10}</label>
        </div>
        <div className="w3-row">
          <label className="bold-label">{t("icd10_name")}:</label>
          <label className="label-margin-left">{item?.icd10name}</label>
        </div>
        <div className="w3-row">
          <label className="bold-label">{t("snomed_code")}:</label>
          <label className="label-margin-left">{item?.snomed}</label>
        </div>
      </div>
    );
  };

  let message =
    error && error?.includes(Consts.DELETE)
      ? t("error_by_deleting_a_disease")
      : t("error_by_retrieving_diseases");

  const errorMessage = error && <ErrorMessage message={message} />;

  return (
    <>
      <div className="w3-row">
        <p>{t("diseases")} </p>
      </div>
      {errorMessage}
      <div className="w3-container">
        {patientDiseases?.length > 0 ? (
          <>
            {patientDiseases?.map((item, i) => {
              return (
                <div
                  className="w3-column w3-round-large w3-margin w3-padding-small w3-border w3-border-blue"
                  key={`disease${i}`}
                >
                  <div className="w3-row w3-left-align">
                    <div className="w3-rest">
                      <label>
                        {formatOnlyDateForGui(item?.begin)}: {item?.name}
                      </label>
                    </div>
                  </div>
                  <div className="w3-row">{createDiseaseItemBody(item)}</div>
                </div>
              );
            })}
          </>
        ) : (
          <div className="w3-container">
            <label>
              {patient
                ? t("not_available")
                : t("you_have_not_yet_entered_any_disease")}
            </label>
          </div>
        )}
      </div>
    </>
  );
};

export default Diseases;
